<template>
	<div class="modal fade" :id="modal.selector" tabindex="-1" role="dialog" aria-hidden="true">
		<div v-if="item" class="modal-dialog" role="document">
			<div class="modal-content">
				<div class="modal-header">
					<div class="btn-toolbar pull-right" role="toolbar">
						<div class="btn-group" role="group" aria-label="...">
							<button type="button" class="close" @click="close">
								<span aria-hidden="true">&times;</span>
							</button>
						</div>
					</div>
					<h4>Añadir Extra</h4>
				</div>
				<div class="modal-body">
					<div class="row">
						<div class="col-md-12">
							<div class="form-group" :class="{ 'has-error' : errors.has('Name') }">
								<label>Nombre</label>
								<input v-validate="'required'" v-model="item.name" name="Name" type="text" class="form-control">
								<small v-show="errors.has('Name')" class="form-text text-danger">
									{{ errors.first('Name') }}
								</small>
							</div>
						</div>
					</div>
					<div class="row">
						<div class="col-md-6">
							<div class="form-group">
								<label>Valor Venta</label>
								<input v-model="item.sale_value" type="number" class="form-control">
							</div>
						</div>
						<div class="col-md-6">
							<div class="form-group">
								<label>Valor Compra</label>
								<input v-model="item.purchase_value" type="number" class="form-control">
							</div>
						</div>
					</div>
					<div class="row">
						<div class="col-md-12">
							<div class="form-group">
								<label>Descripción</label>
								<quill-editor v-model="item.description"
									ref="descriptionEditorCreate">
								</quill-editor>
							</div>
						</div>
					</div>
				</div>
				<div class="modal-footer">
					<button ref="btnStore" @click="validate(false)" type="button" class="btn btn-success">Guardar</button>
					<button type="button" class="btn btn-default" @click="close">Cerrar</button>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import swal from 'sweetalert2'
	import Ladda from 'ladda'

	export default {
		props: ['user', 'isAuth', 'data', 'type'],
		data () {
			return {
				modal: {
					selector: 'modal-product-extras-create',
				},

				item: {
					product_id: null,
					product_storage_id: null,
					name: null,
					sale_value: null,
					purchase_value: null,
					description: null,
				},
			}
		},
		methods: {
			open() {
				if(this.type == 'product') {
					this.item.product_id = this.data.id
				} else {
					if(this.type == 'productStorage') {
						this.item.product_storage_id = this.data.id
					}
				}
				var modal = $('#'+this.modal.selector)
				modal.modal('show')
			},
			close () {
				var modal = $('#'+this.modal.selector)
				modal.modal('hide')
			},
			clearData() {
				this.item.product_id = null
				this.item.product_storage_id = null
				this.item.name = null
				this.item.sale_value = null
				this.item.purchase_value = null
				this.item.description = null
			},
			validate(update) {
				var that = this
				return this.$validator.validateAll().then((result) => {
					if(result) {
						that.store()
					}
					return result
				})
			},
			store: function() {
				var loading = Ladda.create(this.$refs.btnStore)
				loading.start()
				var api = null
				if(this.type == 'product') {
					var api = 'admin/management/products/' + this.data.id + '/add/extra'
				} else {
					if(this.type == 'productStorage') {
						var api = 'admin/management/products/storages/' + this.data.id + '/add/extra'
					}
				}
				this.$http.post(api, this.item)
					.then(response => {
						loading.stop()
						this.close()
						var data = response.body.data
						this.data.extras.push(data)
						this.$emit('updated')
						this.clearData()
						swal({
							title: response.body.title,
							text: response.body.text,
							type: response.body.type,
						})
					}).catch(function(response) {
						loading.stop()
						console.log(response)
					})
			},
		},
	}
</script>


// WEBPACK FOOTER //
// src/components/management/extras/views/Create.vue